webpackJsonp([30],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__ = __webpack_require__(2712);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f4171be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__ = __webpack_require__(4137);
function injectStyle (ssrContext) {
  __webpack_require__(4135)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f4171be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f4171be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



// 人事-员工管理 搜索表单校验（均为可选项）
var searchRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入员工姓名', 'string', 'blur', false))],
  status: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择员工状态', 'integer', 'change', false))],
  phone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的手机号', 'string', 'blur', false), {
    pattern: /^1[3456789]\d{9}$/i
  })],
  email: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的邮箱', 'email', 'blur', false))]

  // 人事-员工管理 新增/编辑表单校验（必填项）
};var formRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入员工姓名', 'string'))],
  gender: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择性别', 'integer', 'change'))],
  phone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的手机号', 'string'), {
    pattern: /^1[3456789]\d{9}$/i
  })],
  email: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的邮箱', 'email'))],
  birthday: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择生日', 'date', 'change'))],
  hire_date: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择入职日期', 'date', 'change'))],
  status: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择员工状态', 'integer', 'change'))]
};

/***/ }),

/***/ 2712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hr_rules__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_dateTimePicker__ = __webpack_require__(1347);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_dateTimePicker__["a" /* default */]],
  data: function data() {
    return {
      id: 0,
      isOnlyView: false,
      formRules: __WEBPACK_IMPORTED_MODULE_2__hr_rules__["a" /* formRules */],
      form: {
        name: '',
        gender: null,
        phone: '',
        email: '',
        birthday: null,
        hire_date: null,
        status: null,
        hire_bcc: [],
        birthday_bcc: []
      },
      inputHireBcc: '',
      inputBirthdayBcc: ''
    };
  },

  computed: {
    isEdit: function isEdit() {
      return !!this.id;
    },
    tablePath: function tablePath() {
      return '/hr/employee';
    }
  },
  created: function created() {
    var id = this.$route.params.id;
    this.isOnlyView = this.$route.meta.isOnlyView; // 仅查看
    if (id) {
      this.id = id;
      this.loadDetail();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map([]), {
    removeBcc: function removeBcc(field, index) {
      this.form[field].splice(index, 1);
    },
    addBccFromInput: function addBccFromInput(field, inputKey) {
      var _this = this;

      var raw = (this[inputKey] || '').trim();
      if (!raw) return;
      var items = raw.split(',').map(function (s) {
        return s.trim();
      }).filter(Boolean);
      items.forEach(function (item) {
        if (item && !_this.form[field].includes(item)) {
          _this.form[field].push(item);
        }
      });
      this[inputKey] = '';
    },
    loadDetail: function loadDetail() {
      var _this2 = this;

      return request.page('getEmployeeDetail', this.id).then(function (_ref) {
        var data = _ref.data;

        // 回填基础字段
        filter.setLoop(_this2.form, data);
        // 日期字段：后端通常返回字符串，这里转换为 Date 供 date-picker 使用
        _this2.form.birthday = data.birthday ? moment(data.birthday, 'YYYY-MM-DD').toDate() : null;
        _this2.form.hire_date = data.hire_date ? moment(data.hire_date, 'YYYY-MM-DD').toDate() : null;
        _this2.form.hire_bcc = Array.isArray(data.hire_bcc) ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.hire_bcc)) : data.hire_bcc ? [data.hire_bcc] : [];
        _this2.form.birthday_bcc = Array.isArray(data.birthday_bcc) ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.birthday_bcc)) : data.birthday_bcc ? [data.birthday_bcc] : [];
      });
    },
    onBack: function onBack() {
      this.$router.push(this.tablePath);
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) {
          return;
        }
        var payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.form, {
          birthday: _this3.form.birthday ? moment(_this3.form.birthday).format('YYYY-MM-DD') : '',
          hire_date: _this3.form.hire_date ? moment(_this3.form.hire_date).format('YYYY-MM-DD') : '',
          hire_bcc: _this3.form.hire_bcc || [],
          birthday_bcc: _this3.form.birthday_bcc || []
          // 编辑模式：带上 id，走 edit 接口
        });if (_this3.isEdit) {
          request.common('editEmployee', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: _this3.id }, payload)).then(function () {
            _this3.$confirm('修改员工成功，是否返回列表页？', '提示', { type: 'success' }).then(function () {
              _this3.onBack();
            }).catch(function () {});
          });
          return;
        }
        // 新增模式
        request.common('addEmployee', payload).then(function () {
          _this3.$confirm('新增员工成功，是否继续录入？', '提示', { type: 'success' }).then(function () {
            _this3.$refs.form.resetFields();
          }, function () {
            _this3.onBack();
          });
        });
      });
    }
  })
});

/***/ }),

/***/ 4135:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4136);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2202cdb9", content, true, {});

/***/ }),

/***/ 4136:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".add-form[data-v-1f4171be]{width:500px;padding:20px}.tag-input-wrap[data-v-1f4171be]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;padding:4px 8px;border:1px solid #dcdfe6;border-radius:4px;min-height:36px;width:100%}.tag-input-wrap .tag-input-inner[data-v-1f4171be]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:120px}.tag-input-wrap .el-tag[data-v-1f4171be]{margin:0}.footer[data-v-1f4171be]{padding:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;gap:20px}", "", {"version":3,"sources":["/workspace/src/views/hr/pages/employee/form.vue"],"names":[],"mappings":"AACA,2BAA2B,YAAY,YAAY,CAClD,AACD,iCAAiC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,yBAAyB,sBAAsB,mBAAmB,QAAQ,gBAAgB,yBAAyB,kBAAkB,gBAAgB,UAAU,CACtR,AACD,kDAAkD,mBAAmB,WAAW,OAAO,eAAe,CACrG,AACD,yCAAyC,QAAQ,CAChD,AACD,yBAAyB,aAAa,oBAAoB,oBAAoB,aAAa,uBAAuB,oBAAoB,2BAA2B,QAAQ,CACxK","file":"form.vue","sourcesContent":["\n.add-form[data-v-1f4171be]{width:500px;padding:20px\n}\n.tag-input-wrap[data-v-1f4171be]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;padding:4px 8px;border:1px solid #DCDFE6;border-radius:4px;min-height:36px;width:100%\n}\n.tag-input-wrap .tag-input-inner[data-v-1f4171be]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:120px\n}\n.tag-input-wrap .el-tag[data-v-1f4171be]{margin:0\n}\n.footer[data-v-1f4171be]{padding:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;gap:20px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":_vm.tablePath}},[_vm._v("员工管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",staticClass:"add-form",attrs:{"disabled":_vm.isOnlyView,"model":_vm.form,"rules":_vm.formRules,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('el-form-item',{attrs:{"label":"员工姓名","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入员工姓名","clearable":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"性别","prop":"gender"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择性别"},model:{value:(_vm.form.gender),callback:function ($$v) {_vm.$set(_vm.form, "gender", $$v)},expression:"form.gender"}},[_c('el-option',{attrs:{"label":"男","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"女","value":"2"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"手机号","prop":"phone"}},[_c('el-input',{attrs:{"placeholder":"请输入手机号","clearable":""},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"邮箱","prop":"email"}},[_c('el-input',{attrs:{"placeholder":"请输入邮箱","clearable":""},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"周年密送","prop":"hire_bcc"}},[_c('div',{staticClass:"tag-input-wrap"},[_vm._l((_vm.form.hire_bcc),function(item,idx){return _c('el-tag',{key:'hire-' + idx,attrs:{"closable":"","size":"small"},on:{"close":function($event){return _vm.removeBcc('hire_bcc', idx)}}},[_vm._v("\n            "+_vm._s(item)+"\n          ")])}),_vm._v(" "),_c('el-input',{staticClass:"tag-input-inner",attrs:{"placeholder":"输入后回车或逗号添加","size":"small"},nativeOn:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.addBccFromInput('hire_bcc', 'inputHireBcc')},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==188){ return null; }return _vm.addBccFromInput('hire_bcc', 'inputHireBcc')}]},model:{value:(_vm.inputHireBcc),callback:function ($$v) {_vm.inputHireBcc=$$v},expression:"inputHireBcc"}})],2)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"生日密送","prop":"birthday_bcc"}},[_c('div',{staticClass:"tag-input-wrap"},[_vm._l((_vm.form.birthday_bcc),function(item,idx){return _c('el-tag',{key:'bd-' + idx,attrs:{"closable":"","size":"small"},on:{"close":function($event){return _vm.removeBcc('birthday_bcc', idx)}}},[_vm._v("\n            "+_vm._s(item)+"\n          ")])}),_vm._v(" "),_c('el-input',{staticClass:"tag-input-inner",attrs:{"placeholder":"输入后回车或逗号添加","size":"small"},nativeOn:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.addBccFromInput('birthday_bcc', 'inputBirthdayBcc')},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==188){ return null; }return _vm.addBccFromInput('birthday_bcc', 'inputBirthdayBcc')}]},model:{value:(_vm.inputBirthdayBcc),callback:function ($$v) {_vm.inputBirthdayBcc=$$v},expression:"inputBirthdayBcc"}})],2)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"生日","prop":"birthday"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"type":"date","format":"yyyy-MM-dd","placeholder":"请选择生日","picker-options":_vm.dateTimePickerOptions},model:{value:(_vm.form.birthday),callback:function ($$v) {_vm.$set(_vm.form, "birthday", $$v)},expression:"form.birthday"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"入职日期","prop":"hire_date"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"type":"date","format":"yyyy-MM-dd","placeholder":"请选择入职日期","picker-options":_vm.dateTimePickerOptions},model:{value:(_vm.form.hire_date),callback:function ($$v) {_vm.$set(_vm.form, "hire_date", $$v)},expression:"form.hire_date"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"员工状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择员工状态"},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}},[_c('el-option',{attrs:{"label":"在职","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"离职","value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"冻结","value":"3"}})],1)],1),_vm._v(" "),(!_vm.isOnlyView)?_c('div',{staticClass:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("保存")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.onBack()}}},[_vm._v("返回")])],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/employee-add.fb97ee56694e07eeb0d0.js